import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import { messages } from '@databases/intl/messages';
import { SHORTCUTS, tooltip } from '@databases/keyboard-shortcuts';
import React from 'react';

import { SELECT_VALUE_MENU_ACTIONS } from '../../../select-value-menu/types';
import {
  ElementAfterShortCutWrapper,
  ElementBeforeIconWrapper,
} from '../../../select-value-menu/ui/components';
import { type SelectionsEffectMenuItemBuilder } from '../types';

export const clearValuesMenuItem: SelectionsEffectMenuItemBuilder = (
  context,
  actions,
  skip
) => {
  if (!context.capabilities.canClearContent) {
    return skip;
  }

  return () => ({
    key: SELECT_VALUE_MENU_ACTIONS.CLEAR_VALUES,
    content: context.formatMessage(messages['value-actions.clear-cells'], {
      valuesCount: '1',
    }),
    onMouseEnter: () => {
      context.selectionsActions.clearSelectionIntent();
    },
    onClick: () => {
      actions.cell.handleClearFields();

      context.closeMenu();
    },
    elemAfter: <ElementAfterShortCutWrapper tooltip={tooltip(SHORTCUTS.CLEAR.keyMap)} />,
    elemBefore: (
      <ElementBeforeIconWrapper>
        <CrossCircleIcon label="" spacing="spacious" />
      </ElementBeforeIconWrapper>
    ),
  });
};
